import React from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import BackButton from '../../../common/BackButton';
import ToolButton from '../../../common/ToolButton';

const TankTools = ({
  history
}) => {
  return (
    <Card>
      <CardBody>
        <ToolButton
          color={"primary"}
          handleClick={() => history.push("/container")}
          icon={"plus"}
          text={"Dodaj Zbiornik"}
        />
        <BackButton />
      </CardBody>
    </Card>
  )
}

TankTools.propTypes = {
  history: PropTypes.object.isRequired
}

export default withRouter(TankTools);
